import React from 'react';
import { Button } from './ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { PAGE_SIZE_OPTIONS } from '../hooks/usePagination';

/** Shared pager for every list in the Suite. Works with server offsets or local slices. */
export const Pagination = ({ total = 0, page, pageSize, onPageChange, onPageSizeChange, label = 'registros', testId = 'pagination' }) => {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 mb-3" data-testid={testId}>
      <p className="text-xs text-muted-foreground" data-testid={`${testId}-range`}>
        Mostrando <span className="font-medium text-foreground">{from}–{to}</span> de {total} {label}
      </p>

      <div className="flex items-center gap-2 sm:ml-auto">
        <Select value={String(pageSize)} onValueChange={(v) => onPageSizeChange(Number(v))}>
          <SelectTrigger className="h-8 w-[136px] text-xs" data-testid={`${testId}-size`}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {PAGE_SIZE_OPTIONS.map(size => (
              <SelectItem key={size} value={String(size)} className="text-xs">{size} por página</SelectItem>
            ))}
          </SelectContent>
        </Select>

        <div className="flex items-center gap-1">
          <Button
            variant="outline" size="sm" className="h-8 px-2"
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
            data-testid={`${testId}-prev`}
          >
            <ChevronLeft className="w-4 h-4" />
          </Button>
          <span className="text-xs text-muted-foreground px-1 whitespace-nowrap" data-testid={`${testId}-page`}>
            {page} / {pages}
          </span>
          <Button
            variant="outline" size="sm" className="h-8 px-2"
            disabled={page >= pages}
            onClick={() => onPageChange(page + 1)}
            data-testid={`${testId}-next`}
          >
            <ChevronRight className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};
